import React, { useContext, useState, useEffect, useCallback } from "react";
import NavbarV3 from "../../../../components/NavbarV3/NavbarV3.tsx";
import "./RelatorioProprietarios.css";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import LoadingComponent from "../../../../components/LoadingComponent/LoadingComponent.tsx";
import SemAutorizacao from "../../../../components/SemAutorizacao/SemAutorizacao";
import { motion } from "framer-motion";
import { useNomeTabela } from "../../../../contexts/NomeTabela.tsx";
import FiltroV2 from "../../../../components/FiltroV2/FiltroV2";
import MultiplosFiltrosRedux from "../../../../contexts/MultiplosFiltros.js";
import { useLocation } from "react-router-dom";
import FiltrosRedux from "../../../../contexts/Filtros.js";
import { getRelatorioProprietarios } from "../../../../services/ModuloGerenciador/Proprietario.js";
import TabelaEstatisticas from "../../../../components/TabelaEstatisticas/TabelaEstatisticas.js";
import { useProfile } from "../../../../contexts/ProfileContext.tsx";

function RelatorioProprietarios() {
	const { dadosTabelaRedux } = useNomeTabela();

	const { profile, hasRegra, contextoEmbarque } = useProfile();

	const { multiplosFiltrosRedux } = useContext(MultiplosFiltrosRedux);

	const [openTelaCheia, setOpenTelaCheia] = useState(true);

	const [loading, setLoading] = useState(true);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const [dadosTabela, setDadosTabela] = useState([]);

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	useEffect(() => {
		setValorInicial();
	}, []);

	const setValorInicial = () => {
		const date = new Date();
		const contexto = "todos";
		const primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1);
		const ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
		var diaPrimeiro = String(primeiroDia?.getDate()).padStart(2, "0");
		var diaUltimo = String(ultimoDia?.getDate()).padStart(2, "0");
		var mesPriemiro = String(date?.getMonth() + 1).padStart(2, "0");
		var anoPrimeiro = date?.getFullYear();
		var dateInicio = anoPrimeiro + "-" + mesPriemiro + "-" + diaPrimeiro;
		var dateFinal = anoPrimeiro + "-" + mesPriemiro + "-" + diaUltimo;
		setValuesPesquisa((current) => ({ ...current, contexto: contexto }));
		setValuesPesquisa((current) => ({
			...current,
			embarqueInicio: dateInicio,
		}));
		setValuesPesquisa((current) => ({ ...current, embarqueFinal: dateFinal }));
	};

	const itensFiltro = [
		{
			nomeColuna: "Frota",
			field: "frota",
		},
		{
			nomeColuna: "Proprietário",
			field: "proprietario",
		},
		{
			nomeColuna: "Média",
			field: "media",
		},
		{
			nomeColuna: "Total",
			field: "total",
		},
	];

	const [valuesPesquisa, setValuesPesquisa] = useState([]);

	const limpar = () => {
		setLoading(true);
		setValuesPesquisa([]);
		setValorInicial();
		buscarSearch();
		setTimeout(() => {
			setLoading(false);
		}, 0);
	};

	const [mesSelecionado, setMesSelecionado] = useState("");

	const buscarSearch = useCallback(
		async (ordenarPor) => {
			if (!profile) return;
			setLoading(true);
			let pesquisaFormatada = `${valuesPesquisa.item}=${valuesPesquisa.pesquisa}`;
			if (multiplosFiltrosRedux && multiplosFiltrosRedux.length > 0) {
				for (let filtro of multiplosFiltrosRedux) {
					pesquisaFormatada += `&${filtro.field}=${filtro.valor}`;
				}
			}
			await getRelatorioProprietarios(
				profile?.token,
				valuesPesquisa.contexto,
				ordenarPor,
				pesquisaFormatada
			)
				.then((result) => {
					const sortedDados = result?.data?.sort((a, b) => {
						const valorA = a.embarquesMes[mesSelecionado] || 0;
						const valorB = b.embarquesMes[mesSelecionado] || 0;
						return valorB - valorA;
					});
					setDadosTabela(sortedDados);
					setLoading(false);
				})
				.catch((error) => {
					if (error.response?.data?.length > 200) {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					} else {
						setTextoErro(error.response.data);
					}
					setOpenToastErro(true);
				});
			setLoading(false);
		},
		[profile, valuesPesquisa, multiplosFiltrosRedux, mesSelecionado]
	);

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	const { setFiltrosRedux } = useContext(FiltrosRedux);

	const location = useLocation();

	useEffect(() => {
		if (valuesPesquisa.contexto) {
			buscarSearch();
		}
	}, [valuesPesquisa.contexto, profile]);

	useEffect(() => {
		buscarSearch();
	}, [mesSelecionado, profile]);

	useEffect(() => {
		if (!profile) return;
		setSemAutorizacao(!hasRegra("Estatísticas Terceiros"));
	}, [profile, hasRegra]);

	useEffect(() => {
		setValuesPesquisa((current) => ({
			...current,
			item: undefined,
			pesquisa: undefined,
		}));
		setFiltrosRedux((current) => ({
			...current,
			item: undefined,
			pesquisa: undefined,
		}));
	}, [location.pathname, contextoEmbarque]);

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			{semAutorizacao ? (
				<>
					<NavbarV3 title="Estatísticas Terceiros" selecionado="RelatorioProprietarios" />
					<SemAutorizacao></SemAutorizacao>
				</>
			) : (
				<div>
					{openTelaCheia ? (
						<NavbarV3 title="Estatísticas Terceiros" selecionado="RelatorioProprietarios" />
					) : (
						<></>
					)}
					{!loading ? (
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
						>
							<div className="faturamentos">
								<div className="header-faturamentos"></div>
								<div className="filtro-embarque-v2">
									<FiltroV2
										classe="div-filtrar-faturamento-v2"
										classOption="select-options"
										itensFiltro={itensFiltro}
										valuesPesquisa={valuesPesquisa}
										setValuesPesquisa={setValuesPesquisa}
										buscarSearch={buscarSearch}
										limpar={limpar}
									/>
								</div>
								<TabelaEstatisticas
									colunas={dadosTabelaRedux.RelatorioProprietarios}
									dados={dadosTabela}
									setMesSelecionado={setMesSelecionado}
									buscarSearch={buscarSearch}
								/>
							</div>
							<div>
								<ToastSucesso
									texto={textoSucesso}
									open={openToastSucesso}
									onClose={handleCloseToastSucesso}
								/>
								<ToastErro
									texto={textoErro}
									open={openToastErro}
									onClose={handleCloseToastErro}
								/>
							</div>
						</motion.div>
					) : (
						<LoadingComponent />
					)}
				</div>
			)}
		</motion.div>
	);
}

export default RelatorioProprietarios;
